// extracted by mini-css-extract-plugin
export default {"SkeletonText":"📚19-10-2_QdYk","pulsing":"📚19-10-2HQVq0"};